export default __webpack_public_path__ + "static/media/web_lever.735dd1f9.svg";